import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/archive",
		component: lazy(() => import("./AdminArchiveCarriersPage")),
	},
]);
